<div class="loading" *ngIf="!loaded"></div>
<div *ngIf="loaded">
  <app-toast-panel></app-toast-panel>
  <div>
    <router-outlet></router-outlet>
    <app-back-to-top [animated]="true"></app-back-to-top>
    <app-loading [hidden]="!loadingService.isLoading()"></app-loading>
  </div>
</div>